import { cn } from "../../lib/cn";

export const inputStyles =
  "w-full rounded-lg border border-border bg-card px-3 py-2.5 text-sm text-foreground placeholder:text-muted-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:cursor-not-allowed disabled:opacity-60";

export function Input({ className, type = "text", ...props }) {
  return (
    <input
      type={type}
      className={cn(inputStyles, className)}
      {...props}
    />
  );
}

export function openNativePicker(event) {
  event.stopPropagation();
  const input = event.currentTarget;
  if (typeof input.showPicker === "function") {
    try {
      input.showPicker();
      return;
    } catch {
      // Some browsers block showPicker without a direct user gesture.
    }
  }
  input.focus();
}

export function DateInput({ className, onClick, onMouseDown, ...props }) {
  return (
    <Input
      type="date"
      className={cn("cursor-pointer", className)}
      onMouseDown={(e) => {
        onMouseDown?.(e);
        e.stopPropagation();
      }}
      onClick={(e) => {
        openNativePicker(e);
        onClick?.(e);
      }}
      {...props}
    />
  );
}

export function TimeInput({ className, onClick, onMouseDown, ...props }) {
  return (
    <Input
      type="time"
      className={cn("cursor-pointer", className)}
      onMouseDown={(e) => {
        onMouseDown?.(e);
        e.stopPropagation();
      }}
      onClick={(e) => {
        openNativePicker(e);
        onClick?.(e);
      }}
      {...props}
    />
  );
}
